import { useCallback, useEffect, useState } from "react";
import "../css/guides.css";
import { Link } from "react-router-dom";
import { Access } from "./docs";
import MerlinDB, { Schema } from "@chrisaxxwell/merlin-db";
import axios from "axios";
import { useBetween } from "use-between";
import { setGuidesAnimation } from "./reference";
import Head from "./head";

var merlin = new MerlinDB();
var guidesSchema = Schema({
   title: { type: String, required: true },
   data: { type: Array, required: true },
});

function getData() {
   return new Promise(resolve => {
      merlin.connect("merlinDB");
      merlin.getModel("guides").then(async e => {
         var guidesModel = merlin.model("guides", guidesSchema);

         resolve(guidesModel.find());

      }).catch((e) => {

         var guidesModel = merlin.model("guides", guidesSchema);

         axios.get("/json/guides.json").then(async e => {
            var insert = await guidesModel.insert(e.data);
            resolve(insert.data);
         });
      });
   })
}

var SharedGuides = () => {
   var [ guides, setGuides ] = useState([
      { title: "", data: [] },
      { title: "", data: [] },
      { title: "", data: [] },
      { title: "", data: [] },
      { title: "", data: [] },
   ]);

   var defineGuides = useCallback(() => {

      getData().then(e => {
         setGuides(e);
      });
   }, []);

   return {
      guides,
      setGuides,
      defineGuides,
   }
}

var useSharedGuides = () => useBetween(SharedGuides);

function GuidesContainer({ guides, id }) {
   return (
      <>
         {
            guides.map((item, i) => (
               !item.title ? (
                  <div key={i} className="lazy-mask title-guides" >
                     <Link>---------------------------------</Link>
                     <div>------------------------------</div>
                     <div>-----------------</div>
                     <div>------------</div>
                     <div>--------------------</div>
                     <div>---------------</div>
                     <div>----------------------</div>
                  </div >
               ) : (
                  <div key={i}>
                     <Link
                        className={id === item.data[ 0 ].to ? "title-guides linked-t" : "title-guides"}
                        to={'/manual/reference/' + item.data[ 0 ].to}
                        onClick={
                           e => {
                              if (!!e.target.closest("#top-guides>div")) {
                                 e.target.closest("#top-guides").className = "";
                              }
                           }
                        }
                     >
                        {item.data[ 0 ].name} <span>{item.data.slice(1).length}</span>
                     </Link>

                     {item.data.slice(1).map((link, i) => (
                        <div key={i} className={id === link.to ? "linked" : null}>
                           <Link to={"/manual/reference/" + link.to} onClick={
                              e => {
                                 if (!!e.target.closest("#top-guides>div")) {
                                    e.target.closest("#top-guides").className = "";
                                 }
                              }
                           }>{link.name}</Link>
                           {link.space ? <br></br> : null}
                        </div>
                     ))}
                  </div >
               )
            ))
         }
      </>
   )
}

export default function Guides() {
   var { guides, defineGuides } = useSharedGuides();

   useEffect(() => {
      window.scrollTo(0, 0)
      defineGuides();
      setGuidesAnimation();

   }, []);

   return (
      <main id="guides">
         <Head props={{
            site_name: "MerlinDB",
            page_type: "website",
            title: "Guides - MerlinDB",
            description: "Explore our comprehensive guides that offer detailed step-by-step instructions to master our tool with excellence and improve your productivity.",
            page_author: "Chris Axxwell",
            index: "index, follow",
            keywords: "Database, database, MerlinDB, IndexedDB, Banco de dados, download, npm, tool",
            canonical: "/download",
            lang: "en_US",
            theme_color: "#250649",
            img_page: "/merlindb-poster.jpg", //imagem que ta dentro de src/files/images/head/
            img_alt: "MerlinDB poster",
            twitter_username_creator: "chrisaxxwell",
            twitter_username: "chrisaxxwell",
            icon: "/merlin-logo.svg", //o icone da pagina em /src/files/
            noCache: false, //adicone true, em paginas de usuario e paginas que nao quer adiionar no cache, se for true entao noa adicionapaginas no cache tipo para paginas de usuario, paginas de blogs atualizados e tals
            //redirect: ["https://www.chrisaxxwell.com", 3], //redireciona a pagina para outra pagina ou outro dominio depois de 3 segundos ou nao defina para 0
         }} />
         <Access data={[
            { link: "../docs", text: "docs", accessible: true },
            { link: "", text: "guides", accessible: false },
            { link: "/manual/reference/starting", text: "Starting", accessible: true },
         ]} />

         <h1>MERLINDB GUIDES <li data-disappear=", 'Your journey starts here, Sim Sala Bim'"></li></h1>
         <h2>For more details visit the routes below, MerlinDB is similar and uses almost all the same methods as MongoDb with a touch of Mongoose <li data-disappear="(incridible tools)"></li>, so you may feel more familiar. Feel free.</h2>
         <GuidesContainer guides={guides} />
         <br />
         <br />
         <Access data={[
            { link: "../docs", text: "docs", accessible: true },
            { link: "", text: "guides", accessible: false },
            { link: "/manual/reference/starting", text: "Starting", accessible: true },
         ]} />
      </main >
   )
}


export { useSharedGuides, GuidesContainer, guidesSchema };